import React from 'react';

import { redirectToLogin } from 'utils/auth';

import loginCta from './loginCta.module.scss';

interface GuestCtaButtonProps {
  /** Button text — use a value from utils/guestCta.GUEST_CTA. */
  label: string;
  /** Optional click override (defaults to redirecting to the login page). */
  onClick?: () => void;
  /** Optional extra class merged onto the shared CTA style. */
  className?: string;
}

/**
 * The guest "Login or Sign up" call-to-action — the shared amber filter-chip
 * pill (loginCta.module.scss `.cta`) wired to the login redirect. Used by the
 * lobby header, multi-table header, and the advisory modal so the button looks
 * and behaves identically everywhere.
 */
const GuestCtaButton: React.FC<GuestCtaButtonProps> = ({ label, onClick, className }) => (
  <button
    type='button'
    className={className ? `${loginCta.cta} ${className}` : loginCta.cta}
    onClick={onClick ?? (() => redirectToLogin())}>
    {label}
  </button>
);

export default GuestCtaButton;
